<script setup lang="ts">
import type { PropType } from 'vue';
import type { Tag } from '@nfc-api/tag';

const props = defineProps({
  tag: {
    type: Object as PropType<Tag>,
    required: true,
  },
});
</script>

<template>
  <div class="text-4xl">{{ 'To be implemented' }}</div>
</template>
